import { useState } from 'react';
import { getProjectDetailsById } from '@/api/projects.api';

const useProjectById = () => {
  const [loading, setLoading] = useState(true);

  const fetchProjectById = async (projectId: string) => {
    try {
      setLoading(true);
      const result = await getProjectDetailsById(projectId);
      if (result.status !== 200) {
        throw Error('Failed to fetch project details');
      }
      return result.data;
    } catch (error) {
      console.error('Error fetching project details:', error);
    } finally {
      setLoading(false);
    }
  };

  return { loading, fetchProjectById };
};

export default useProjectById;
